package com.dotdrives.web.pages.giving

import com.dotdrives.model.*
import kotlin.math.roundToInt
import kotlinx.serialization.json.*
import react.FC
import react.Key
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.fieldset
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.legend
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.strong
import web.cssom.ClassName
import web.html.InputType
import web.html.button
import web.html.checkbox
import web.html.text

internal val GivingGiftFields =
    FC<GivingSectionProps> { props ->
        val state = props.state
        val controller = props.controller
        val form = state.form ?: return@FC
        fieldset {
            disabled = state.locked
            legend { +"Your gift" }
            val frequencies =
                listOfNotNull(
                    "once" to "One time",
                    ("monthly" to "Monthly").takeIf { form.config.toggles.monthlyGiving },
                    ("quarterly" to "Quarterly").takeIf { form.config.toggles.quarterlyGiving },
                )
            if (frequencies.size > 1)
                div {
                    className = ClassName("give-frequency")
                    frequencies.forEach { (value, label) ->
                        button {
                            type = web.html.ButtonType.button
                            className = ClassName(if (state.frequency == value) "selected" else "")
                            ariaPressed =
                                (state.frequency == value).unsafeCast<react.dom.aria.AriaPressed>()
                            onClick = { controller.setFrequency(value) }
                            +label
                        }
                    }
                }
            div {
                className = ClassName("give-amounts")
                form.config.amounts.forEach { amount ->
                    button {
                        key = amount.amount.toString().unsafeCast<Key>()
                        type = web.html.ButtonType.button
                        className =
                            ClassName(
                                "give-amount" +
                                    if (
                                        givingCents(state.amount) ==
                                            (amount.amount * 100).roundToInt()
                                    )
                                        " selected"
                                    else ""
                            )
                        onClick = {
                            controller.setAmount(givingAmount((amount.amount * 100).roundToInt()))
                        }
                        strong { +money(amount.amount) }
                        if (amount.label.isNotBlank() && !redundantAmountLabel(amount))
                            span { +amount.label }
                    }
                }
            }
            if (form.config.toggles.customAmount)
                label {
                    className = ClassName("give-field")
                    span { +"Custom amount (USD)" }
                    input {
                        type = InputType.text
                        value = state.amount
                        placeholder = "0.00"
                        onChange = { controller.setAmount(it.currentTarget.value) }
                    }
                }
            if (form.contributionPolicy.enabled && form.config.toggles.coverFees)
                label {
                    className = ClassName("give-check")
                    input {
                        type = InputType.checkbox
                        checked = state.coverFees
                        onChange = { controller.setCoverFees(it.currentTarget.checked) }
                    }
                    span {
                        +"${form.contributionPolicy.label}${if (state.coverFees) " (+${money(state.contributionCents / 100.0)})" else ""}"
                    }
                }
        }
    }
